/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTimeISO: { input: any; output: any; }
};

export type BrowseSchedulesView = {
  __typename?: 'BrowseSchedulesView';
  scheduleId: Scalars['String']['output'];
};

export type ChooseDirectionInput = {
  directionId: Scalars['String']['input'];
  stopSelectionId: Scalars['String']['input'];
};

export type ChooseRouteInput = {
  routeId: Scalars['String']['input'];
  scheduleId: Scalars['String']['input'];
  stopSelectionId: Scalars['String']['input'];
};

export type ChooseStopInput = {
  stopId: Scalars['String']['input'];
  stopSelectionId: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  chooseDirection: MutationResponse;
  chooseRoute: MutationResponse;
  chooseStop: MutationResponse;
  publishSchedule: MutationResponse;
  refreshScheduledBuses: MutationResponse;
};


export type MutationChooseDirectionArgs = {
  input: ChooseDirectionInput;
};


export type MutationChooseRouteArgs = {
  input: ChooseRouteInput;
};


export type MutationChooseStopArgs = {
  input: ChooseStopInput;
};


export type MutationPublishScheduleArgs = {
  input: PublishScheduleInput;
};


export type MutationRefreshScheduledBusesArgs = {
  input: RefreshScheduledBusesInput;
};

export type MutationError = {
  __typename?: 'MutationError';
  message?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type PublishScheduleDirectionsInput = {
  directionId: Scalars['String']['input'];
  directionName: Scalars['String']['input'];
  routeId: Scalars['String']['input'];
};

export type PublishScheduleInput = {
  directions: Array<InputMaybe<PublishScheduleDirectionsInput>>;
  routes: Array<InputMaybe<PublishScheduleRoutesInput>>;
  scheduleId: Scalars['String']['input'];
  scheduledArrivals: Array<InputMaybe<PublishScheduleScheduledArrivalsInput>>;
  stops: Array<InputMaybe<PublishScheduleStopsInput>>;
};

export type PublishScheduleRoutesInput = {
  routeId: Scalars['String']['input'];
  routeName: Scalars['String']['input'];
};

export type PublishScheduleScheduledArrivalsInput = {
  arrivalId: Scalars['String']['input'];
  destinationLabel: Scalars['String']['input'];
  directionId: Scalars['String']['input'];
  routeId: Scalars['String']['input'];
  scheduledTime: Scalars['String']['input'];
  serviceDay: Scalars['String']['input'];
  stopId: Scalars['String']['input'];
};

export type PublishScheduleStopsInput = {
  directionId: Scalars['String']['input'];
  stopId: Scalars['String']['input'];
  stopName: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  browseSchedules: Array<BrowseSchedulesView>;
  viewScheduledBuses: ViewScheduledBusesView;
};

export type RefreshScheduledBusesInput = {
  stopSelectionId: Scalars['String']['input'];
};

export type ViewScheduledBusesView = {
  __typename?: 'ViewScheduledBusesView';
  buses?: Maybe<Array<Maybe<ViewScheduledBusesViewBuses>>>;
  calculatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  directionId?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Array<Maybe<ViewScheduledBusesViewDirections>>>;
  routeId?: Maybe<Scalars['String']['output']>;
  routes?: Maybe<Array<Maybe<ViewScheduledBusesViewRoutes>>>;
  scheduleId?: Maybe<Scalars['String']['output']>;
  serviceDay?: Maybe<Scalars['String']['output']>;
  stopId?: Maybe<Scalars['String']['output']>;
  stopSelectionId?: Maybe<Scalars['String']['output']>;
  stops?: Maybe<Array<Maybe<ViewScheduledBusesViewStops>>>;
};

export type ViewScheduledBusesViewBuses = {
  __typename?: 'ViewScheduledBusesViewBuses';
  destinationLabel?: Maybe<Scalars['String']['output']>;
  minutesUntil?: Maybe<Scalars['Float']['output']>;
  scheduledTime?: Maybe<Scalars['String']['output']>;
};

export type ViewScheduledBusesViewDirections = {
  __typename?: 'ViewScheduledBusesViewDirections';
  directionId?: Maybe<Scalars['String']['output']>;
  directionName?: Maybe<Scalars['String']['output']>;
  routeId?: Maybe<Scalars['String']['output']>;
};

export type ViewScheduledBusesViewRoutes = {
  __typename?: 'ViewScheduledBusesViewRoutes';
  routeId?: Maybe<Scalars['String']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
};

export type ViewScheduledBusesViewStops = {
  __typename?: 'ViewScheduledBusesViewStops';
  directionId?: Maybe<Scalars['String']['output']>;
  stopId?: Maybe<Scalars['String']['output']>;
  stopName?: Maybe<Scalars['String']['output']>;
};

export type BrowseSchedulesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type BrowseSchedulesQueryQuery = { __typename?: 'Query', browseSchedules: Array<{ __typename: 'BrowseSchedulesView', scheduleId: string }> };

export type ViewScheduledBusesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewScheduledBusesQueryQuery = { __typename?: 'Query', viewScheduledBuses: { __typename: 'ViewScheduledBusesView', scheduleId?: string | null, stopSelectionId?: string | null, routeId?: string | null, directionId?: string | null, stopId?: string | null, serviceDay?: string | null, calculatedAt?: any | null, routes?: Array<{ __typename: 'ViewScheduledBusesViewRoutes', routeId?: string | null, routeName?: string | null } | null> | null, directions?: Array<{ __typename: 'ViewScheduledBusesViewDirections', directionId?: string | null, directionName?: string | null, routeId?: string | null } | null> | null, stops?: Array<{ __typename: 'ViewScheduledBusesViewStops', stopId?: string | null, stopName?: string | null, directionId?: string | null } | null> | null, buses?: Array<{ __typename: 'ViewScheduledBusesViewBuses', scheduledTime?: string | null, minutesUntil?: number | null, destinationLabel?: string | null } | null> | null } };

export type PublishScheduleMutationMutationVariables = Exact<{
  input: PublishScheduleInput;
}>;


export type PublishScheduleMutationMutation = { __typename?: 'Mutation', publishSchedule: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type ChooseRouteMutationMutationVariables = Exact<{
  input: ChooseRouteInput;
}>;


export type ChooseRouteMutationMutation = { __typename?: 'Mutation', chooseRoute: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type ChooseDirectionMutationMutationVariables = Exact<{
  input: ChooseDirectionInput;
}>;


export type ChooseDirectionMutationMutation = { __typename?: 'Mutation', chooseDirection: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type ChooseStopMutationMutationVariables = Exact<{
  input: ChooseStopInput;
}>;


export type ChooseStopMutationMutation = { __typename?: 'Mutation', chooseStop: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type RefreshScheduledBusesMutationMutationVariables = Exact<{
  input: RefreshScheduledBusesInput;
}>;


export type RefreshScheduledBusesMutationMutation = { __typename?: 'Mutation', refreshScheduledBuses: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };


export const BrowseSchedulesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrowseSchedulesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"browseSchedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleId"}}]}}]}}]} as unknown as DocumentNode<BrowseSchedulesQueryQuery, BrowseSchedulesQueryQueryVariables>;
export const ViewScheduledBusesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewScheduledBusesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewScheduledBuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleId"}},{"kind":"Field","name":{"kind":"Name","value":"routes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"routeId"}},{"kind":"Field","name":{"kind":"Name","value":"routeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"directions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"directionId"}},{"kind":"Field","name":{"kind":"Name","value":"directionName"}},{"kind":"Field","name":{"kind":"Name","value":"routeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"stopId"}},{"kind":"Field","name":{"kind":"Name","value":"stopName"}},{"kind":"Field","name":{"kind":"Name","value":"directionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stopSelectionId"}},{"kind":"Field","name":{"kind":"Name","value":"routeId"}},{"kind":"Field","name":{"kind":"Name","value":"directionId"}},{"kind":"Field","name":{"kind":"Name","value":"stopId"}},{"kind":"Field","name":{"kind":"Name","value":"serviceDay"}},{"kind":"Field","name":{"kind":"Name","value":"buses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledTime"}},{"kind":"Field","name":{"kind":"Name","value":"minutesUntil"}},{"kind":"Field","name":{"kind":"Name","value":"destinationLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculatedAt"}}]}}]}}]} as unknown as DocumentNode<ViewScheduledBusesQueryQuery, ViewScheduledBusesQueryQueryVariables>;
export const PublishScheduleMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishScheduleMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublishScheduleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PublishScheduleMutationMutation, PublishScheduleMutationMutationVariables>;
export const ChooseRouteMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChooseRouteMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChooseRouteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chooseRoute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ChooseRouteMutationMutation, ChooseRouteMutationMutationVariables>;
export const ChooseDirectionMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChooseDirectionMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChooseDirectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chooseDirection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ChooseDirectionMutationMutation, ChooseDirectionMutationMutationVariables>;
export const ChooseStopMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChooseStopMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChooseStopInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chooseStop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ChooseStopMutationMutation, ChooseStopMutationMutationVariables>;
export const RefreshScheduledBusesMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshScheduledBusesMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefreshScheduledBusesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshScheduledBuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RefreshScheduledBusesMutationMutation, RefreshScheduledBusesMutationMutationVariables>;